<div class="footer">
  <div class="footer-left">
    <img
      class="footer-left-logo-european-union"
      src="assets/img/logo-european-union.png"
      alt="logo footer european union"
    />
    <img
      class="footer-left-logo-space"
      src="assets/img/logo-recover-transform.svg"
      alt="logo footer recover transform"
    />
    <img
      class="footer-left-logo-space"
      src="assets/img/logo-next-generation.svg"
      alt="logo footer next generation"
    />
    <img
      class="footer-left-logo-space"
      src="assets/img/logo-generalitat.svg"
      alt="logo footer generalitat"
    />
  </div>
  <div class="footer-right">
    <p class="footer-text">SCE {{ currentYear }} &#64;</p>
  </div>
</div>
